module.exports = __webpack_public_path__ + "img/243.605afbb4.png";